export class DisplayedClusterArea {
  constructor(public lat: number, public lon: number, public radius: number) {
  }
}
